import { Box, Divider, Snackbar, Stack, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { TabPanel } from "../tab-panel.js";
import useDealBuilderAlertsStore from "../stores/deal-builder-alerts.store.ts";
import BondsPage from "./pages/debt-service-page.tsx";
import useDealBuilderResultStore from "../stores/deal-builder-result.store.ts";
import { DragAndDropProvider } from "./pages/bonds-page/drag-and-drop-context.tsx";
import ProductionPage from "./pages/production-page.tsx";
import SummaryPage from "./pages/summary-page.tsx";
import DealBuilderButtonPanel from "./deal-builder-buttons-panel.tsx";
import DealBuilderInputPanel from "./deal-builder-input-panel.tsx";
import SourcesAndUsesPage from "./pages/sources-and-uses-page.tsx";
import SimilarDealsPage from "./pages/similar-deals-page.tsx";

enum Page {
  SOURCES_AND_USES,
  DEBT_SERVICE,
  STATISTICS,
  PRICING_AND_PRODUCTION,
  SIMILAR_DEALS,
}

export default function DealBuilderMain() {
  const { DealBuilderService } = useDealBuilderResultStore();
  const { snackMessage, setSnackMessage } = useDealBuilderAlertsStore();
  const [activeTab, setActiveTab] = useState<Page>(Page.PRICING_AND_PRODUCTION);

  return (
    <Stack direction="row" width="100%">
      <Stack direction="column">
        <DealBuilderButtonPanel />
        <DealBuilderInputPanel />
      </Stack>

      {DealBuilderService && (
        <Stack direction="column" sx={{ background: "white", flex: 1 }}>
          <Tabs 
            value={activeTab} 
            onChange={(_e, v) => setActiveTab(v)}
          >
            <Tab label="Sources & Uses" value={Page.SOURCES_AND_USES} />
            <Tab label="Debt Service" value={Page.DEBT_SERVICE} />
            <Tab label="Pricing & Production" value={Page.PRICING_AND_PRODUCTION} />
            <Tab label="Bond Summary & Statistics" value={Page.STATISTICS} />
            <Tab label="Similar Deals" value={Page.SIMILAR_DEALS} />
          </Tabs>
          <Divider />
          <Box width="100%" flex={1} sx={{ background: "#fafafa" }}>
            <TabPanel activeTab={activeTab} name={Page.DEBT_SERVICE}>
                <DragAndDropProvider>
                  <BondsPage builder={DealBuilderService} />
                </DragAndDropProvider>
            </TabPanel>
            <TabPanel activeTab={activeTab} name={Page.PRICING_AND_PRODUCTION}>
                <DragAndDropProvider>
                  <ProductionPage builder={DealBuilderService} />
                </DragAndDropProvider>
            </TabPanel>
            <TabPanel activeTab={activeTab} name={Page.STATISTICS}>
              <SummaryPage builder={DealBuilderService} />
            </TabPanel>
            <TabPanel activeTab={activeTab} name={Page.SOURCES_AND_USES}>
              <SourcesAndUsesPage builder={DealBuilderService} />
            </TabPanel>
            <TabPanel activeTab={activeTab} name={Page.SIMILAR_DEALS}>
              <SimilarDealsPage builder={DealBuilderService} />
            </TabPanel>
          </Box>
        </Stack>
      )}

      <Snackbar
        color="error"
        open={snackMessage !== undefined}
        autoHideDuration={6000}
        onClose={() => setSnackMessage(undefined)}
        message={snackMessage}
      />
    </Stack>
  )
}

